<template functional>
    <component class="ur-data-grid__content__cell__value"
            :is="$options.cellCompo({props})"
            :row="injections.rowInfo.row" :value="props.value" :text="props.text" :edit="edit"
            :me="injections.gridInfo.caller" :field="props.field"
            :style="$options.style.valueStyle({props,injections})"
            v-ur-tooltip.overflow.empty="props.text"/>
</template>


<script>
const COMPO_MIXIN = {
    computed: {
        $caller() {return this.$parent.gridInfo.caller}
    }
}

export default {
    name : "urDataGridContentCellCompo",
    inject : ['gridInfo', 'rowInfo'],
    props : {
        field : {type:Object},
        text  : null, /* type any, String will.. maybe OK? */
        value : null, /* type any */
        edit  : {type:Boolean, default:false}
    },
    cellCompo({props}){
        var field = props.field;
        if(typeof field.component === 'string') {
            return {
                props:['row','value','text', 'me', 'field'],
                mixins : [COMPO_MIXIN],
                template : field.component
            }
        } else {
            var __compo = field.component;
            __compo.mixins = [COMPO_MIXIN];
            return __compo;
        }
    },
    style:{
        // [COMPUTED] Style, Cell value style
        valueStyle({props,injections}) {
            var field = props.field;
            let style = {};
            if(field.align) {style['text-align'] = field.align}
            return style;
        }
    }
}
</script>
